import {Box, Card, Skeleton, Typography} from "@mui/material";
import {useCustomNavigation} from "hooks/useCustomNavigation";
import {userService} from "services/userService";
import {UserAvatar} from "./components/UserAvatar/UserAvatar";
import {List} from "components/Admin/Pages/List/List";

export const UserList = () => {
  const {navigate} = useCustomNavigation();

  return (
    <List
      queryLimit={50}
      getList={userService.getList}
      loader={<Skeleton sx={{height: "106px"}} variant="rounded"/>}
    >
      {(user) => (
        <Card
          onClick={() => navigate(`./${user.id}`)}
          elevation={0}
          sx={styles.container}
        >
          <UserAvatar user={user}/>
          <Box sx={{flexGrow: 1}}>
            <Typography sx={styles.username}>
              {user.username}
            </Typography>
            <Typography sx={styles.email}>{user.email}</Typography>
          </Box>
        </Card>
      )}
    </List>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "start",
    gap: "20px",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: "background.paper",
    padding: "20px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  username: {
    fontWeight: 500,
  },
  email: {
    color: "text.secondary",
  },
};
